import {Button, Col, Form, Row, Space, Spin, message} from "antd";
import {InputFields} from "components/common";
import React, {useEffect, useState} from "react";
import {dataFields} from "./ModalAction.config";
import {employeeService} from "api";
import Notification from "../../../../../../../../../components/common/notification/notification";

const ModalAction = props => {
  const {data, closeModal, type, getListStore} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);

  const add = async () => {
    const data = form.getFieldsValue();
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),

      };
      const res = await employeeService.createDepartment(data);
      setLoading(false);
      closeModal();
      Notification("success", "Đã thêm mới phòng ban");
      await getListStore();
      form.resetFields();
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400){
        Notification("error", error.response.data);
      }else {
        Notification("error", "Đã có lỗi thêm mới thông tin phòng ban");
      }

    }
  };
  const update = async () => {

    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
        id:data.id,

      };
      const res = await employeeService.editDepartment(params);
      setLoading(false);
      closeModal();
      await getListStore();
      Notification("success", "Đã cập nhật phòng ban");

    } catch (error) {
      setLoading(false);
      if (error.response.status === 400){
        Notification("error", error.response.data);
      }else {
        Notification("error", "Đã có lỗi khi sửa thông tin phòng ban");
      }


    }
  };
  const onFinish = values => {
    if (type == "Thêm") {
      add();
    } else {
      update();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row justify="end" style={{ marginTop: 20 }}>
              <Col>
                <Space>
                  <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};

export default ModalAction;
